import { useAuthStore } from '@/stores/auth';

export const useDevOnly = (authorizedEmails = []) => {
    // Default email addresses that have dev access in production
    const defaultAuthorizedDevEmails = [];

    // Combine default emails with any additional emails passed as parameters
    const allAuthorizedEmails = [...defaultAuthorizedDevEmails, ...authorizedEmails];

    const isAuthorizedDevUser = (additionalEmails = []) => {
        const authStore = useAuthStore();
        const userEmail = authStore.user?.apiUser?.email;
        const emailsToCheck = [...allAuthorizedEmails, ...additionalEmails];
        return !!(userEmail && emailsToCheck.includes(userEmail));
    };

    const isDev = (options = {}) => {
        // Extract emails and databases from options object
        const emails = options.allowedEmails || [];
        const databases = options.allowedDatabases || [];

        return import.meta.env.DEV || isTenant('freshqa', ...databases) || isAuthorizedDevUser(emails);
    };
    const devOnly = isDev;

    const isTenant = (...allowedDatabases) => {
        const authStore = useAuthStore();
        return allowedDatabases.some((db) => authStore.account?.fhirApiUri?.includes(db));
    };

    const isProfile = () => isTenant('bnprofile');

    const isBnSupport = () => {
        const authStore = useAuthStore();
        return authStore.isBnSupport;
    };

    const isBnSupportUser = () => {
        const authStore = useAuthStore();
        return authStore.isBnSupportUser;
    };

    return {
        devOnly,
        isDev,
        isTenant,
        isProfile,
        isBnSupport,
        isBnSupportUser,
        isAuthorizedDevUser,
    };
};
